<template>
  <div>
    <list row-key="DeviceTaskId" ref="list" unit="设备任务" :page="page" :query-params="params"
      :show-checkbox="$permission.canDel()" :show-query="showQuery" :get-data-func="api.list" @reset="$refs.treeSelect.clearHandle()">
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <!-- <el-form-item label="设备编号">
          <el-input v-model="params.DeviceNo" placeholder="请填写设备编号" clearable></el-input>
        </el-form-item> -->
        <el-form-item label="归属机构">
          <tree-select ref="treeSelect" :props="props" :options="TreeData" :value="params.DpId" :clearable="true"
            :accordion="true" :parentSelect="true" placeholder="请选择" @node-select="onTreeSelect($event)"
            style="width:193px" />
        </el-form-item>
        <el-form-item label="IMEI">
          <el-input v-model="params.ImeiMac" type="number" placeholder="请填写IMEI" clearable></el-input>
        </el-form-item>
        <el-form-item label="设备型号">
          <el-input v-model="params.DeviceModel" placeholder="请填写设备型号" clearable></el-input>
        </el-form-item>
        <el-form-item label="车牌号">
          <el-input v-model="params.CarNo" placeholder="请填写车牌号" clearable></el-input>
        </el-form-item>
        <el-form-item label="任务类型">
          <el-select v-model="params.TaskType" clearable>
            <el-option :value="0" label="实时视频"></el-option>
            <el-option :value="1" label="远程重启"></el-option>
            <el-option :value="2" label="远程更新"></el-option>
            <el-option :value="3" label="更新密码"></el-option>
            <el-option :value="4" label="重置密码"></el-option>
            <el-option :value="5" label="更新TCP"></el-option>
            <el-option :value="6" label="手动更新"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="params.Status" clearable>
            <el-option :value="0" label="待执行"></el-option>
            <el-option :value="1" label="执行中"></el-option>
            <el-option :value="2" label="成功"></el-option>
            <el-option :value="3" label="失败"></el-option>
          </el-select>
        </el-form-item>
      </template>
      <template slot="table">
        <!-- <el-table-column prop="DeviceNo" label="设备编号" /> -->
        <el-table-column prop="DpName" label="归属机构" />
        <el-table-column prop="ImeiMac" label="IMEI" />
        <el-table-column prop="DeviceModel" label="设备型号" />
        <el-table-column prop="DeviceType" label="设备类型" />
        <el-table-column prop="CarNo" label="车牌号" />
        <el-table-column prop="AddTime" label="添加时间" width="150" />
        <el-table-column prop="ExecTime" label="收到时间" width="150" />
        <el-table-column prop="Remark" label="备注" />
        <el-table-column prop="TaskType" label="任务类型" width="90" align="center">
          <template slot-scope="{ row }">
            <span v-if="row.TaskType==0">实时视频</span>
            <span v-else-if="row.TaskType==1">远程重启</span>
            <span v-else-if="row.TaskType==2">远程更新</span>
            <span v-else-if="row.TaskType==3">更新密码</span>
            <span v-else-if="row.TaskType==4">重置密码</span>
            <span v-else-if="row.TaskType==5">更新TCP</span>
            <span v-else-if="row.TaskType==6">手动更新</span>
          </template>
        </el-table-column>
        <el-table-column prop="Status" label="状态" width="80" align="center">
          <template slot-scope="{ row }">
            <el-tag type="primary" v-if="row.Status==0">待执行</el-tag>
            <el-tag type="warning" v-else-if="row.Status==1">执行中</el-tag>
            <el-tag type="success" v-else-if="row.Status==2">成功</el-tag>
            <el-tag type="danger" v-else-if="row.Status==3">失败</el-tag>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="AddTime" label="创建时间" width="160" /> -->
        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
  </div>
</template>
<script>
  import listMixin from "@/mixins/list";
  import list from "@/components/common/list";
  import treeSelect from "@/components/common/treeSelect";

  export default {
    mixins: [listMixin],
    components: { list,treeSelect },
    data() {
      return {
        api: require("@/api/op/task").default,
        dpApi: require("@/api/basic/dp").default,
        params: {
          DeviceNo: "",
          DeviceModel: "",
          ImeiMac: "",
          CarNo: "",
          TaskType: null,
          DpId: null,
          DpIdChain: null,
        },
        TreeData: [],
        props: {
          value: "DpId",
          label: "DpName",
          children: "children",
        },
      };
    },
    beforeMount() {
      this.dpApi.getAuthList({ DpTypes: [2, 3, 4, 5], Status: 3, NoReturnParent: true }).then((res) => {
        this.TreeData = this.$commonJs.toTreeData(res.Data, "DpId");
      });
    },
    methods: {
    onTreeSelect(t) {
      if (!t) {
        this.params.DpIdChain = "";
        this.params.DpId = null;
      } else {
        this.params.DpIdChain = t.IdChain;
        this.params.DpId = t.DpId;
      }
    },
      delRange(ids) {
        this.api.delete({ ids }).then((res) => {
          if (res.Code == 0) {
            this.$message.success("删除成功");
            this.reload();
          } else {
            this.$message.error(res.Msg);
          }
        });
      },
    },
  };
</script>